import { getAge, getAlertMessageFunction, isCheckHouseHolder } from '../../../common/Util';

// 공제불가항목 필터
//2026년에 반드시 해야할 일 !!!!
//value 2로 들어올경우 체크못하도록 하는 로직 추가해야함.
//
//2026년 검토사항 - PC(DocumentContainer.js)와 모바일 공제불가 로직 차이점:
//1. 직계비속(htm002=="4") 나이<=20 or 나이>=60: 모바일은 htm012(신용카드) X, PC는 가능
//2. 직계비속 20세 미만 + htm003=="2": PC는 htm011,htm014,htm012 X, 모바일은 이 조건 없음
//3. 직계존속(htm002=="1"||"2") 60세↑ + 기본공제X: 모바일은 htm012 X, PC는 주석처리(가능)
//4. 직계존속 60세↓ + 기본공제O + 장애X: PC는 htm011(교육비) X, 모바일은 htm009(보험료) X (버그?)
//5. 형제자매(htm002=="5") + 기본공제O: 모바일은 htm012 무조건 X, PC는 가능
export const filterNonItemList = list => {
  const nonItemList = [];

  list.forEach((item, index) => {
    // 성별 및 외국인 플래그 초기화
    let sexFlag = '0';
    let age = 0;

    const { htm001, htm002, htm074, htm003, htm041, htm004, htmYy } = item;

    if (htm001.trim().length === 13) {
      sexFlag = htm001.substring(6, 7);

      const birthday = htm001.substring(0, 6);
      age = getAge(birthday, sexFlag, htmYy);
      sexFlag = ['1', '3', '5', '7'].includes(sexFlag) ? '1' : '2';
    }
    nonItemList[index] = nonItemList[index] || [];
    //소득요건
    if (htm074 != '1') nonItemList[index].push('htm074');

    //기본공제
    if (htm003 != '1') nonItemList[index].push('htm003');

    //본인이거나 배우자or직계비속이면서 기본공제해당자
    if (htm002 == '0' || ((htm002 == '3' || htm002 == '4') && htm003 == '1')) {
      //기초수급 신용카드 X
      if (htm041 == '1') nonItemList[index].push('htm012');

      if (htm002 != '0') {
        //배우자or직계비속이면서 기본공제해당자 주택자금,연금X
        nonItemList[index].push('htm061');
        nonItemList[index].push('htm062');
      }

      return;
    }

    //배우자
    if (htm002 == '3') {
      //보험료, 신용카드, 주택자금, 연금X
      nonItemList[index].push('htm009');
      nonItemList[index].push('htm012');
      nonItemList[index].push('htm061');
      nonItemList[index].push('htm062');
      // 소득금액 100 이상
      if (htm074 != '1') {
        //교육비, 기부금X
        nonItemList[index].push('htm011');
        nonItemList[index].push('htm014');
      }
      return;
    }

    //직계비속
    if (htm002 == '4') {
      //주택자금, 연금 X
      nonItemList[index].push('htm061');
      nonItemList[index].push('htm062');
      if (age <= 20 || age >= 60) {
        // 보험료, 의료비, 신용카드 X
        nonItemList[index].push('htm009');
        // nonItemList[index].push('htm010'); //25.01.02 자녀는 무조건 의료비보이게 수정
        nonItemList[index].push('htm012');
        //소득100만원이하X
        if (htm074 != '1') {
          //교육비, 기부금X
          nonItemList[index].push('htm011');
          nonItemList[index].push('htm014');
        }

        //20세미만 60초과
      } else {
        //보험료 X
        nonItemList[index].push('htm009');
        //소득100만원이하X
        if (htm074 != '1') {
          //교육비, 기부금, 신용카드 X
          nonItemList[index].push('htm011');
          nonItemList[index].push('htm014');
          nonItemList[index].push('htm012');
        }
      }

      return;
    }
    //위탁아동
    if (htm002 == '6') {
      //보험료, 신용카드, 주택자금, 연금X
      // nonItemList[index].push('htm009');
      nonItemList[index].push('htm012');
      nonItemList[index].push('htm061');
      nonItemList[index].push('htm062');

      //소득100만원이하X
      if (htm074 != '1') {
        //교육비, 기부금 X
        nonItemList[index].push('htm011');
        nonItemList[index].push('htm014');
      }

      //기본공제 아닐때만 보험료X 25.01.22 문팀장님 요청
      //기존로직 : 위탁아동일때 조건상관없이 보험료공제 X -> 기본공제일 때는 보험료 공제해달라는 요청임
      if (htm003 != '1') {
        nonItemList[index].push('htm009');
      }

      return;
    }

    //소득자 직계존속, 배우자 직계존속
    if (htm002 == '1' || htm002 == '2') {
      //주택자금, 연금X
      nonItemList[index].push('htm061');
      nonItemList[index].push('htm062');

      if (age >= 60) {
        //소득100만원이하 O, 기본공제X
        if (htm074 == '1' && htm003 != '1') {
          //의료비, 신용카드 X
          nonItemList[index].push('htm010');
          nonItemList[index].push('htm012');
        }

        //기본공제O
        if (htm003 == '1') {
          //기본공제이면서 기초수급
          if (htm041 == '1') {
            //신용카드X
            nonItemList[index].push('htm012');
          }
          //기본공제 아니고,
        } else {
          //보험료X 신용카드X
          nonItemList[index].push('htm009');
          nonItemList[index].push('htm012');
          //소득세 100이하도 아님
          if (htm074 != '1') {
            //기부금X
            nonItemList[index].push('htm014');
          }
        }

        //장애아니면
        if (htm004 != '1') {
          //교육비X
          nonItemList[index].push('htm011');
        }
        //60세 미만
      } else {
        //20세 미만, 소득세 100이하, 기본공제 아니면
        if (age <= 20 && htm074 == '1' && htm003 != '1') {
          //의료비 X
          nonItemList[index].push('htm010');
        }

        //기본공제인데
        if (htm003 == '1') {
          //장애아니면
          if (htm004 != '1') {
            //보험료 X
            nonItemList[index].push('htm009');
          }
          //기본공제 아닌데
        } else {
          //보험료, 교육비X
          nonItemList[index].push('htm009');
          nonItemList[index].push('htm011');
          if (htm074 != '1') {
            //기부금X
            nonItemList[index].push('htm014');
          }
        }
        if (!(htm074 == '1' && htm041 != '1')) {
          //신용카드 X
          nonItemList[index].push('htm012');
        }
      }

      return;
    }

    //형제자매
    if (htm002 == '5') {
      //신용, 주택, 연금 X
      nonItemList[index].push('htm012');
      nonItemList[index].push('htm061');
      nonItemList[index].push('htm062');
      //기본공제 아니면
      if (htm003 != '1') {
        //보험료 X
        nonItemList[index].push('htm009');
        //20세 미만 60세 초과 소득 100 이하
        if (age <= 20 || age >= 60) {
          //교육비X
          nonItemList[index].push('htm011');
          //소득 100 이하
          if (htm074 == '1') {
            //의료비 X
            nonItemList[index].push('htm010');
          }
        } else {
          if (htm074 != '1') {
            //교육비 X
            nonItemList[index].push('htm011');
          }
        }

        if (htm074 != '1') {
          //기부금 X
          nonItemList[index].push('htm014');
        }
      }
      return;
    }
  });

  return nonItemList;
};

//유효성 체크
export const checkValidity = (dataList, index, key, value, t) => {
  const alertMessage = getAlertMessageFunction();
  let { htm002, htm003, htm004, htm039, htm074, htm080, htm036 } = dataList[index];
  // key에 해당하는 값을 value로 업데이트
  if (key == 'htm003') htm003 = value;
  if (key == 'htm004') htm004 = value;
  if (key == 'htm039') htm039 = value;
  if (key == 'htm074') htm074 = value;
  if (key == 'htm080') htm080 = value;
  if (key == 'htm002') htm002 = value;
  if (key == 'htm036') htm036 = value;

  let age = 0;
  //한부모 유/무
  if (htm080 == '1') {
    for (const item of dataList) {
      const sexFlag = item.htm001.substring(6, 7);
      const birthday = item.htm001.substring(0, 6);
      age = getAge(birthday, sexFlag, item.htmYy);

      if (item.htm002 === '3') {
        // 배우자 있으면 한부모X
        alertMessage(t('alertMessage.message4'));
        return false;
      }
      if (item.htm002 === '6' && item.htm004 !== '1') {
        // 직계비속 소득자 없으면 한부모X
        alertMessage(t('alertMessage.message5'));
        return false;
      }
    }
  }

  if (htm074 != '1' && htm003 == '1') {
    //소득 100 안넘으면 기본 X
    alertMessage(t('alertMessage.message1'));
    return false;
  }

  if (htm002 == '6' && age > 20) {
    //만 20세 안넘으면 위탁 X
    alertMessage(t('alertMessage.message2'));
    return false;
  }

  if (htm039 == '1' && age < 70) {
    //경로우대는 70세 이상
    alertMessage(t('alertMessage.message3'));
    return false;
  }

  //사위 며느리는 장애인만 선택가능
  if (htm036 == '3' || htm036 == '4') {
    if (htm004 != '1') {
      alertMessage(t('alertMessage.message6'));
      return false;
    }
  }

  //기본공제 대상자인데 체크안한 경우
  if (htm003 != '1') {
    if (htm039 == '1') {
      //경로우대 대상자가 되려면 기본공제 체크해야함
      alertMessage(t('alertMessage.message7'));
      return false;
    }

    if (htm002 != '0' && htm002 != '3' && age <= 20) {
      //20세이하는 기본공제 대상자일 수 있음
      alertMessage(t('alertMessage.message8'));
    }

    if (htm002 != '0' && htm002 != '3' && age >= 60) {
      //60세이상은 기본공제 대상자일 수 있음
      alertMessage(t('alertMessage.message9'));
    }
  }

  //기본공제 대상자가 아닌데 공제대상 체크한 경우
  if (htm003 == '1') {
    //장애인이 아닌데
    if (htm004 != '1') {
      if (htm002 != '0' && htm002 != '3' && age > 20 && age < 60) {
        alertMessage(t('alertMessage.message10'));
        return false;
      }

      //기본공제이면서 70세 이상은 경로우대임
      if (age >= 70 && htm039 != '1' && htm002 != '0') {
        alertMessage(t('alertMessage.message11'));
      }
    }
  }

  return true;
};
